module.exports = __webpack_public_path__ + "static/media/020.639cd2e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/020.jpg
// module id = 317
// module chunks = 0